export default {
    earned: 10,
};
